import AvatarStackForSpace from './AvatarStackForSpace';

export default AvatarStackForSpace;
